import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { firebaseConfig } from './firebaseConfig';
import { IPayloadMessageListener } from './index';

initializeApp(firebaseConfig);
const messaging = getMessaging();

export const requestForToken = (registration?: ServiceWorkerRegistration) =>
  getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPIDKEY,
    serviceWorkerRegistration: registration,
  }).then((res) => {
    return res;
  });

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload as IPayloadMessageListener | unknown);
    });
  });
